import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import ReactInterval from 'react-interval';
import { LineChart } from '@mui/x-charts/LineChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export interface IIpsDataComunidadesSexChartState {
    data: any[];
}

export default class IpsDataComunidadesSexChart extends React.Component<{}, IIpsDataComunidadesSexChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            IPs por comunidad autónoma
                        </Typography>
                        <Stack direction={'row'}>
                            <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalMen()
                            }
                            </Typography>
                            <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalWomen()
                            }
                            </Typography>
                        </Stack>
                    </Box>
                    {
                        this.state.data.length > 0 && (
                            <LineChart
                                dataset={this.state.data}
                                xAxis={[{ scaleType: 'point', dataKey: 'comunidadAutonoma' }]}
                                series={[
                                    { dataKey: 'hombres', label: 'Hombres', color: Common.MAN_BORDER_COLOR },
                                    { dataKey: 'mujeres', label: 'Mujeres', color: Common.WOMAN_BORDER_COLOR}
                                ]}
                                height={450}
                                margin={{
                                    bottom: 100
                                }}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        )
                    }
                    {
                        this.state.data.length == 0 && (
                            <div className="textCenter" style={{margin: '20px 0px'}}>
                                <CircularProgress/>
                            </div>
                        )
                    }
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/masters/ip/data/comunidadesautonomas/sexo/h`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetTotalFieldWomenData(data);
        })
    }

    private GetTotalFieldWomenData(sourceData: any[]) {
        let url = `${Common.END_POINT}/masters/ip/data/comunidadesautonomas/sexo/m`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.comunidadAutonoma == response[i].comunidadAutonoma;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.comunidadAutonoma < b.comunidadAutonoma) { return -1; }
                if(a.comunidadAutonoma > b.comunidadAutonoma) { return 1; }
                return 0;
            });
            
            this.setState({
                data: data
            })
        })
    }

    private GetTotalMen() {
        const data = this.state.data.filter((value: any) => {
            return value.hombres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.hombres;
        }, 0);

        return sum;
    }

    private GetTotalWomen() {
        const data = this.state.data.filter((value: any) => {
            return value.mujeres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.mujeres;
        }, 0);

        return sum;
    }
}